import { Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import {
    TestProjectInputEditorContent,
    TestProjectInputEditorActions,
    getTestProjectInputEditorTitle
} from './TestProjectInputEditorPresentation';
import type { TestProjectInputDialogProps } from './types';

type Props = TestProjectInputDialogProps & { onMapInputs: () => void };

const TestProjectInputMappingDialog: React.FC<Props> = ({ store, draft, onMapInputs }) => {
    const confirmation = draft.isConfirming;

    return (
        <Modal
            title={getTestProjectInputEditorTitle(draft)}
            visible
            onCancel={store.cancelEditing}
            closable={!store.isSubmitting}
            keyboard={!store.isSubmitting}
            maskClosable={false}
            destroyOnClose
            centered
            width={850}
            footer={
                <TestProjectInputEditorActions
                    store={store}
                    draft={draft}
                    confirmation={confirmation}
                    onMapInputs={onMapInputs}
                    onCancel={store.cancelEditing}
                />
            }
        >
            <TestProjectInputEditorContent store={store} draft={draft} confirmation={confirmation} />
        </Modal>
    );
};

export default observer(TestProjectInputMappingDialog);
